import Fidelity from '@/assets/image/useCases/tokenizedRWA/Fidelity.png'
import Blockstreet from '@/assets/image/useCases/tokenizedRWA/Blockstreet.png'
import AssetoFinance from '@/assets/image/useCases/tokenizedRWA/AssetoFinance.png'
import Pharos from '@/assets/image/useCases/tokenizedRWA/Pharos.png'
import HTCO from '@/assets/image/useCases/tokenizedRWA/HTCO.png'

import ContentImg1 from '@/assets/image/useCases/tokenizedRWA/content_img1.png'
import ContentImg2 from '@/assets/image/useCases/tokenizedRWA/content_img2.png'
import ContentImg3 from '@/assets/image/useCases/tokenizedRWA/content_img3.png'
import ContentImg4 from '@/assets/image/useCases/tokenizedRWA/content_img4.png'
import './index.scss'
import { useMediaQuery } from 'react-responsive';
const trustList = [
  {
    logo: Fidelity,
  }, {
    logo: Blockstreet,
  }, {
    logo: AssetoFinance,
  }, {
    logo: Pharos,
  }, {
    logo: HTCO,
  }
]

const TokenizedRWAContent = () => {
  const isDesktop = useMediaQuery({ minWidth: 769 });

  return (
    <div className={`tokenized-RWA-list text-[#fff]`}>
      {
        isDesktop ? (
          <>
            <div className={`tokenized-RWA-list-item`}>
              <div className={`w-1340 flex items-center trust-wrap tokenized-RWA-list-item-content`}>
                <div className={`trust-title w-[268px] text-[18px] text-center leading-[60px] h-[60px]`}>Trusted by
                </div>
                <div className={`trust-list flex h-[60px] items-center pl-[6px]`}>
                  {
                    trustList.map((item, i) => (
                      <div key={i} className={`trust-list-item flex items-center ml-[40px]`}>
                        <img src={item.logo} className={`h-[22px]`} />
                      </div>
                    ))
                  }
                </div>
              </div>
            </div>
            <div className={`tokenized-RWA-list-item`}>
              <div className={`w-1340 flex items-center tokenized-RWA-list-title tokenized-RWA-list-item-content`}>
                “Vishwa is the first crypto company I have ever formally<br /> endorsed - team impressed me with their
                technical innovation capabilities and execution on GTM”
              </div>
            </div>
            <div className={`tokenized-RWA-list-item`}>
              <div className={`w-1340 flex items-center tokenized-RWA-list-subtitle tokenized-RWA-list-item-content`}>
                <div className={`tokenized-RWA-list-subtitle-l pl-[94px] pr-[66px]`}>Dr. Chris Nixon Cox</div>
                <div className={`flex-1 tokenized-RWA-list-subtitle-r pl-[108px]`}>CHAIRMAN, HTCO</div>
              </div>
            </div>
            <div className={`tokenized-RWA-list-item`}>
              <div className={`w-1340 flex items-center tokenized-RWA-list-item-content`}>
                <div style={{ borderRight: '1px solid #434343' }}
                     className={`flex-1 flex justify-center items-center pt-[44px] pb-[44px]`}>
                  <img src={ContentImg1} className={`h-[244px]`} />
                </div>
                <div className={`flex-1 flex justify-center items-center`}>
                  <img src={ContentImg2} className={`h-[244px]`} />
                </div>
              </div>
            </div>
            <div className={`tokenized-RWA-list-item`}>
              <div className={`w-1340 flex content-wrap tokenized-RWA-list-item-content`}>
                <div style={{ borderRight: '1px solid #434343' }}
                     className={`flex-1 content-item pt-[40px] pb-[18px] pl-[96px] pr-[102px]`}>
                  <div className={`content-item-title mb-[10px]`}>
                    On-Chain Utility
                  </div>
                  <div className={`content-item-desc`}>
                    Use tokenized RWAs as collateral, borrow against them, and deploy them into yield strategies
                    directly
                    on-chain.
                  </div>
                </div>
                <div className={`flex-1 content-item pt-[40px] pb-[18px] pl-[96px] pr-[102px]`}>
                  <div className={`content-item-title mb-[10px]`}>Active Capital</div>
                  <div className={`content-item-desc`}>
                    Tokenized assets plug into autonomous financial workflows instead of sitting idle as passive
                    representations.
                  </div>
                </div>
              </div>
            </div>
            <div className={`tokenized-RWA-list-item`}>
              <div className={`w-1340 flex items-center tokenized-RWA-list-item-content`}>
                <div style={{ borderRight: '1px solid #434343' }}
                     className={`flex-1 flex justify-center items-center pt-[44px] pb-[44px]`}>
                  <img src={ContentImg3} className={`h-[244px]`} />
                </div>
                <div className={`flex-1 flex justify-center items-center`}>
                  <img src={ContentImg4} className={`h-[244px]`} />
                </div>
              </div>
            </div>
            <div className={`tokenized-RWA-list-item`}>
              <div className={`w-1340 flex content-wrap tokenized-RWA-list-item-content`}>
                <div style={{ borderRight: '1px solid #434343' }}
                     className={`flex-1 content-item pt-[40px] pb-[60px] pl-[96px] pr-[102px]`}>
                  <div className={`content-item-title mb-[10px]`}>Custody + Upside</div>
                  <div className={`content-item-desc`}>
                    Institutions keep full economic exposure while assets remain with regulated custodians, since
                    execution
                    uses verifiable proofs instead of moving the underlying.
                  </div>
                </div>
                <div className={`flex-1 content-item pt-[40px] pb-[60px] pl-[96px] pr-[102px]`}>
                  <div className={`content-item-title mb-[10px]`}>Custom Terms</div>
                  <div className={`content-item-desc`}>
                    Structure yield, maturity, and credit conditions on-chain to match institutional mandates and risk
                    requirements.
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            <div className={`tokenized-RWA-list-item`}>
              <div className={`w-1340 trust-wrap tokenized-RWA-list-item-content`}>
                <div className={`trust-title text-[18px] text-center leading-[60px] h-[60px]`}>
                  Trusted by
                </div>
                <div className={`trust-list flex flex-wrap items-center justify-center p-[0_20px_20px]`}>
                  {
                    trustList.map((item, i) => (
                      <div key={i} className={`trust-list-item flex items-center m-[10px]`}>
                        <img src={item.logo} className={`h-[22px]`} />
                      </div>
                    ))
                  }
                </div>
              </div>
            </div>

            <div className={`tokenized-RWA-list-item`}>
              <div style={{padding: '20px',fontSize: '20px'}} className={`w-1340 flex items-center tokenized-RWA-list-title tokenized-RWA-list-item-content`}>
                “Vishwa is the first crypto company I have ever formally endorsed - team impressed me with their
                technical innovation capabilities and execution on GTM”
              </div>
            </div>
            <div className={`tokenized-RWA-list-item`}>
              <div className={`w-1340 tokenized-RWA-list-subtitle tokenized-RWA-list-item-content text-center`}>
                <div className={`tokenized-RWA-list-subtitle-l p-[20px]`} style={{fontSize: '20px', borderBottom: '1px solid #434343', borderRight: '0'}}>Dr. Chris Nixon Cox</div>
                <div className={`tokenized-RWA-list-subtitle-r p-[20px]`} style={{fontSize: '20px'}}>CHAIRMAN, HTCO</div>
              </div>
            </div>
            <div className={`tokenized-RWA-list-item`}>
              <div className={`w-1340 tokenized-RWA-list-item-content`}>
                <div style={{ borderBottom: '1px solid #434343' }}
                     className={`flex-1 flex justify-center items-center p-[20px]`}>
                  <img src={ContentImg1} />
                </div>
                <div className={`flex-1 flex justify-center items-center p-[20px]`}>
                  <img src={ContentImg2} />
                </div>
              </div>
            </div>
            <div className={`tokenized-RWA-list-item`}>
              <div className={`w-1340 content-wrap tokenized-RWA-list-item-content`}>
                <div style={{ borderBottom: '1px solid #434343' }}
                     className={`flex-1 content-item p-[20px]`}>
                  <div className={`content-item-title mb-[10px]`}>
                    On-Chain Utility
                  </div>
                  <div className={`content-item-desc`}>
                    Use tokenized RWAs as collateral, borrow against them, and deploy them into yield strategies
                    directly
                    on-chain.
                  </div>
                </div>
                <div className={`flex-1 content-item p-[20px]`}>
                  <div className={`content-item-title mb-[10px]`}>Active Capital</div>
                  <div className={`content-item-desc`}>
                    Tokenized assets plug into autonomous financial workflows instead of sitting idle as passive
                    representations.
                  </div>
                </div>
              </div>
            </div>
            <div className={`tokenized-RWA-list-item`}>
              <div className={`w-1340  tokenized-RWA-list-item-content`}>
                <div style={{ borderBottom: '1px solid #434343' }}
                     className={`flex-1 flex justify-center items-center p-[20px]`}>
                  <img src={ContentImg3} className={`h-[244px]`} />
                </div>
                <div className={`flex-1 flex justify-center items-center p-[20px]`}>
                  <img src={ContentImg4} className={`h-[244px]`} />
                </div>
              </div>
            </div>
            <div className={`tokenized-RWA-list-item`}>
              <div className={`w-1340 content-wrap tokenized-RWA-list-item-content`}>
                <div style={{ borderBottom: '1px solid #434343' }}
                     className={`flex-1 content-item p-[20px]`}>
                  <div className={`content-item-title mb-[10px]`}>Custody + Upside</div>
                  <div className={`content-item-desc`}>
                    Institutions keep full economic exposure while assets remain with regulated custodians, since
                    execution
                    uses verifiable proofs instead of moving the underlying.
                  </div>
                </div>
                <div className={`flex-1 content-item p-[20px]`}>
                  <div className={`content-item-title mb-[10px]`}>Custom Terms</div>
                  <div className={`content-item-desc`}>
                    Structure yield, maturity, and credit conditions on-chain to match institutional mandates and risk
                    requirements.
                  </div>
                </div>
              </div>
            </div>
          </>
        )
      }
    </div>
  )
}

export default TokenizedRWAContent